import { v4 as uuidv4 } from "uuid";

export const createLayoutObject = ({
  id = uuidv4(),
  name = "",
  keys = [],
  createdAt = new Date(),
}) => {
  return {
    id,
    name,
    keys,
    createdAt,
  };
};

export const createLayoutKeyObject = ({
  id = uuidv4(),
  label = "",
  color = "#e5e6e6",
  layoutId = null,
  productId = null,
  showImage = false,
  type = null,
  position = null,
  action = null,
  link = null,
  labelColor = null,
}) => ({
  id,
  label,
  color,
  layoutId,
  productId,
  showImage,
  type,
  position,
  action,
  link,
  labelColor,
});
